/*  MUI  */
import { Checkbox, FormControlLabel, TableHead, TableRow } from '@mui/material';

/*  React  */
import React, { useMemo, useState } from 'react';

/* Internal Components */
import { ManagedTableHeaderCell } from './ManagedTableHeaderCell';

export const ManagedTableHeaders = ({
    disabled,
    filters,
    handleSelectAll,
    headers,
    setFilters,
    setPage,
    setSortState,
    sortState
}) => {
    const [selectAll, setSelectAll] = useState(null);

    const selectAllHeader = useMemo(
        () => ({
            align: 'center',
            renderHeader: (
                <FormControlLabel
                    key={`editAllHeaderCheckbox${selectAll}`}
                    control={
                        <Checkbox
                            checked={!!selectAll}
                            onChange={(e) => {
                                setSelectAll(!selectAll);
                                handleSelectAll(e.target.checked);
                            }}
                            style={{ padding: 0 }}
                        />
                    }
                    sx={{ margin: 0 }}
                />
            ),
            sortable: false
        }),
        [handleSelectAll, selectAll]
    );

    const tableHeaders = useMemo(
        () => (handleSelectAll ? [selectAllHeader].concat(headers) : headers),
        [handleSelectAll, headers, selectAllHeader]
    );

    return (
        <TableHead
            data-testid="managedTableHeaders"
            data-trackid="managedTableHeaders"
        >
            <TableRow key="headers">
                {tableHeaders.map((header) => (
                    <ManagedTableHeaderCell
                        disabled={disabled}
                        filters={filters}
                        header={header}
                        key={`managedTableHeader_${header.key}`}
                        setFilters={setFilters}
                        setPage={setPage}
                        setSortState={setSortState}
                        sortState={sortState}
                    />
                ))}
            </TableRow>
        </TableHead>
    );
};
